import React, { useEffect } from "react";
import videoRedirectic from "../../assets/video/redirect.mp4";
import { shortenStakeUrl } from "../../components/functions/FunctionsGames";
import { managerClonerBetHome } from "../../global/GlobalVariables";
import { managerFunctionCloneBetHome } from "../../global/GlobalFunctions";


function dataGetTwinBlaze(dataMakers){
      try{
        const dataMakersDecoded = JSON.parse(dataMakers);
        const twinsData = dataMakersDecoded['twinsData'] !== undefined && typeof(dataMakersDecoded['twinsData']) === 'string' ? dataMakersDecoded['twinsData'] : '';
        const twinsDataFragmented = twinsData
        .split('~')
        .reduce((acc, pair) => {
          const [key, value] = pair.split(':');
          acc[key] = value;
          return acc;
        }, {});

        const twinDataValues = Object.values(twinsDataFragmented)
        let twinDataValuesChanged = [];
        for(let i = 0; i < twinDataValues.length; i++){
          let twinValue = twinDataValues[i];
          if (twinValue.length === 1){
            break;
          }
          twinDataValuesChanged.push(twinValue);
        }
        let len_twinDataValuesChanged =  twinDataValuesChanged.length;
        let lastIndex_twinDataValuesChanged = len_twinDataValuesChanged - 1;
        let lastValue_twinDataValuesChanged = twinDataValuesChanged[lastIndex_twinDataValuesChanged];

        twinDataValuesChanged.pop();
        lastIndex_twinDataValuesChanged -= 1;
        twinDataValuesChanged[lastIndex_twinDataValuesChanged] = twinDataValuesChanged[lastIndex_twinDataValuesChanged] + "-" + lastValue_twinDataValuesChanged

        
        const twinsDataPartUrl = "/" + twinDataValuesChanged.join("/");
        
        const newTwinsDataPartUrl = encodeURIComponent(twinsDataPartUrl);
        return {partUrl: twinsDataPartUrl, partUrlEncoded:newTwinsDataPartUrl};
      }
      catch{
        return {partUrl: "", partUrlEncoded:""};
      }
}


function Redirect(props) {
  const { dataMakers, dataLinks, dataArb } = props;
  useEffect(() => {
    setTimeout(() => {
      let widthScreen = window.innerWidth;
      let urlBet = dataArb["url_bet"];

      const nameBetHomeLower = dataArb["name_bet_home"].toLowerCase();
      
      //if (nameBetHomeLower === "stake") {
      //  urlBet = shortenStakeUrl(urlBet);
      //}

      
      if (!managerClonerBetHome["allBetHomeAbleToClone"].includes(nameBetHomeLower) === true){
      
        let listBettingHouseMaster = managerClonerBetHome["allBetHomeAbleToClone"].filter(item => (nameBetHomeLower in  managerClonerBetHome[item]) );
      
        if(listBettingHouseMaster.length > 0){
      
          let bettingHouseMaster = listBettingHouseMaster[0];

          let newURLBet = managerFunctionCloneBetHome(
            managerClonerBetHome,
            bettingHouseMaster,
            nameBetHomeLower,
            urlBet,
          );

          urlBet = newURLBet;
      
        }
      
      }


      if (nameBetHomeLower === "reals") {
        let listPartUrl = dataGetTwinBlaze(dataMakers);
        let newURLBet = urlBet + listPartUrl.partUrlEncoded;
        urlBet = newURLBet;
      }
      else if (nameBetHomeLower === "betvip") {
        let listPartUrl = dataGetTwinBlaze(dataMakers);
        let newURLBet = urlBet + listPartUrl.partUrl;
        urlBet = newURLBet;
      }

      window.location.href = urlBet;
    }, 3000);
  }, []);

  return (
    <div>
      <style>
        {`
          body{
            overflow: hidden;
            background-color: #2b950d;
          }
        `}
      </style>
      <div
        id="navigation"
        data-markers={dataMakers}
        data-links={dataLinks}
      ></div>

      <div>
        <video className="video-background" autoPlay muted loop>
          <source src={videoRedirectic} type="video/mp4" />
          Seu navegador não suporta a tag de vídeo.
        </video>
      </div>
    </div>
  );
}

export default Redirect;
